import { jsx as _jsx } from "react/jsx-runtime";
import MuiDialogTitle from '@mui/material/DialogTitle';
import { getEmphasizedFontWeight } from '@famly/mf_theme';
import { useBreakpoints } from '@famly/mf_util_breakpoints';
import { useDataProps } from '@famly/mf_ts-utils_data-aria-props';
/**
 * Correctly styled dialog title. Inside a `Dialog` it becomes the dialog's accessible name on its own.
 *
 * @param id replaces the id the `Dialog` links its name to, so pass it only together with the same
 *   `aria-labelledby` on that `Dialog`
 */
export const DialogTitle = (props) => {
    const { title, id } = props;
    const dataProps = useDataProps(props);
    const { isMobileLandscapeAndLarger } = useBreakpoints();
    return (_jsx(MuiDialogTitle, { id: id, ...dataProps, sx: theme => ({
            padding: 0,
            marginTop: 6,
            marginLeft: 6,
            marginBottom: 4,
            color: theme.modernFamlyTheme.colorPalette.n400,
            fontWeight: getEmphasizedFontWeight('h6'),
            // ellipsis
            width: { base: '77%', mobileLandscape: '80%' },
            display: '-webkit-box',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: isMobileLandscapeAndLarger ? 1 : 2,
        }), children: title }));
};
